<template>
  <div
    class="notification"
    :class="entryClass(type)"
  >
    <button type="button" class="close" @click="$emit('close')">
      <span aria-hidden="true">&times;</span>
    </button>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    autoclose: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    entryClass(type) {
      if (type === 'error') return 'alert alert-danger';
      return 'alert alert-success';
    },
  },
  mounted() {
    if (this.autoclose) {
      setTimeout(() => {
        this.$emit('close');
      }, 5000);
    }
  },
};
</script>
